var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    staticClass: "mb-4"
  }, [_c('BaseTitle', [_vm._v("Help")])], 1), _c('InfoBlock', [_vm._v(" Unable to find what you're looking for? Submit a ticket below, email help@mottomortgage.com or call 866-MOTTO60; hours are M-F 8 AM – 6 PM (ET) ")]), _c('div', {
    class: _vm.$style.helpSearchContent
  }, [_c('h2', {
    staticClass: "motto-blue-text text-center d-none d-lg-block"
  }, [_vm._v("How can we help you?")]), _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    class: _vm.$style.searchContainer
  }, [_c('BaseInputText', {
    class: _vm.$style.searchBar,
    attrs: {
      "name": "searchQuery",
      "placeholder": "Search your question"
    },
    on: {
      "update": _vm.updateSearchQuery
    }
  }), _c('MottoIcon', {
    class: _vm.$style.searchIcon,
    attrs: {
      "name": "Search"
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "slide-y"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isQueryEmpty,
      expression: "isQueryEmpty"
    }]
  }, [_c('p', {
    staticClass: "p1 motto-blue-text text-center d-none d-lg-block"
  }, [_vm._v("Or explore these categories")]), _c('div', {
    class: _vm.$style.categoryIconContainer
  }, _vm._l(_vm.categories, function (category, index) {
    return _c('CategoryIconSelector', {
      key: "".concat(category).concat(index),
      attrs: {
        "category-name": category,
        "active": _vm.activeCategory === category
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.selectCategory(category);
        }
      }
    });
  }), 1)])]), _c('h3', {
    class: _vm.$style.faqTitle
  }, [_vm._v("Frequently Asked Questions")]), _vm.filteredQuestions.length ? _c('div', {
    class: _vm.$style.questionsContainer
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.filteredQuestions, function (question, index) {
    return _c('div', {
      key: "".concat(question.question).concat(index)
    }, [_c('FaqQuestion', {
      class: _vm.$style.questionBlock,
      attrs: {
        "question": question.question,
        "answer": question.answer,
        "image-url": question.imageUrl
      }
    })], 1);
  }), 0)], 1) : _vm._e(), !_vm.filteredQuestions.length ? _c('div', {
    staticClass: "my-5 text-center"
  }, [_c('p', {
    staticClass: "p1 color-dark-gray"
  }, [_vm._v("No questions were found")])]) : _vm._e(), _c('h4', {
    staticClass: "text-center color-primary-charcoal font-weight-bold"
  }, [_vm._v("Still need help?")]), _c('BaseButton', {
    class: _vm.$style.submitButton,
    attrs: {
      "theme": "lightBlue"
    },
    on: {
      "click": _vm.openTicket
    }
  }, [_c('span', [_vm._v("Submit a ticket")])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }